// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-scroll {
  --overflow: hidden;
}

.invisible {
  width: 100%;
  height: calc(26 * var(--width-ratio));
  background: transparent;
}

.modal-div {
  margin-left: calc(37 * var(--width-ratio));
  margin-right: calc(37 * var(--width-ratio));
  background: white;
  border-radius: 10px;
  height: calc(174 * var(--width-ratio));
}
.modal-div ion-avatar {
  width: calc(64 * var(--width-ratio));
  height: calc(64 * var(--width-ratio));
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0%);
  border: 4px;
  border-color: white;
  border-style: solid;
  background: white;
}
.modal-div .top-image {
  background-image: url("/assets/img/bg-pattern.png");
  background-size: cover;
  height: calc(50 * var(--width-ratio));
}
.modal-div .content {
  padding-left: calc(12 * var(--width-ratio));
  padding-right: calc(12 * var(--width-ratio));
}
.modal-div .content .title {
  margin-top: calc(12 * var(--width-ratio));
  text-align: center;
}
.modal-div .content .subtitle {
  margin-top: calc(2 * var(--width-ratio));
  text-align: center;
}
.modal-div .content .mybutton {
  margin-top: calc(8 * var(--width-ratio));
  --background: var(--ion-color-primary);
  width: 100%;
  height: calc(42 * var(--width-ratio));
  --border-radius: 30px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/watch-expert-modal/watch-expert-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;EACA,qCAAA;EACA,uBAAA;AACF;;AAEA;EACE,0CAAA;EACA,2CAAA;EAEA,iBAAA;EACA,mBAAA;EACA,sCAAA;AAAF;AAEE;EACE,oCAAA;EACA,qCAAA;EACA,kBAAA;EACA,MAAA;EAEA,SAAA;EACA,8BAAA;EAEA,WAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,mDAAA;EACA,sBAAA;EACA,qCAAA;AAHJ;AAME;EACE,2CAAA;EACA,4CAAA;AAJJ;AAMI;EACE,yCAAA;EACA,kBAAA;AAJN;AAOI;EACE,wCAAA;EACA,kBAAA;AALN;AAQI;EACE,wCAAA;EAEA,sCAAA;EAEA,WAAA;EACA,qCAAA;EACA,qBAAA;AARN","sourcesContent":[".no-scroll {\n  --overflow: hidden;\n}\n\n.invisible {\n  width: 100%;\n  height: calc(26 * var(--width-ratio));\n  background: transparent;\n}\n\n.modal-div {\n  margin-left: calc(37 * var(--width-ratio));\n  margin-right: calc(37 * var(--width-ratio));\n\n  background: white;\n  border-radius: 10px;\n  height: calc(174 * var(--width-ratio));\n\n  ion-avatar {\n    width: calc(64 * var(--width-ratio));\n    height: calc(64 * var(--width-ratio));\n    position: absolute;\n    top: 0;\n    // left: calc(155 * var(--width-ratio)); // 這個寫法, ipad會跑版, 換下面的\n    left: 50%;\n    transform: translate(-50%, 0%);\n\n    border: 4px;\n    border-color: white;\n    border-style: solid;\n    background: white;\n  }\n\n  .top-image {\n    background-image: url(\"/assets/img/bg-pattern.png\");\n    background-size: cover;\n    height: calc(50 * var(--width-ratio));\n  }\n\n  .content {\n    padding-left: calc(12 * var(--width-ratio));\n    padding-right: calc(12 * var(--width-ratio));\n\n    .title {\n      margin-top: calc(12 * var(--width-ratio));\n      text-align: center;\n    }\n\n    .subtitle {\n      margin-top: calc(2 * var(--width-ratio));\n      text-align: center;\n    }\n\n    .mybutton {\n      margin-top: calc(8 * var(--width-ratio));\n\n      --background: var(--ion-color-primary);\n      // width: calc(277 * var(--width-ratio));\n      width: 100%;\n      height: calc(42 * var(--width-ratio));\n      --border-radius: 30px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
